import { render } from "./partner.vue?vue&type=template&id=2df72d80"
import script from "./partner.vue?vue&type=script&lang=js"
export * from "./partner.vue?vue&type=script&lang=js"

import "./partner.vue?vue&type=style&index=0&id=2df72d80&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__